import { render, staticRenderFns } from "./MaxSettings.vue?vue&type=template&id=34322092"
import script from "./MaxSettings.vue?vue&type=script&lang=js"
export * from "./MaxSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports